import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {IntegrationChannel} from "./integration.type";

@Component({
    selector: "notificationconfig",
    templateUrl: "./notificationconfig.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
    ]
})
export class NotificationConfigComponent {

    @Input()
    config: IntegrationChannel;

    @Output()
    onEnabled: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    onTest: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    onRemove: EventEmitter<string> = new EventEmitter<string>();

    enable(name: string){
        this.onEnabled.next(name);
    }
    test(name: string){
        this.onTest.next(name);
    }
    remove(name: string){
        this.onRemove.next(name);
    }
}